import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Download from './views/Download.vue'
import FAQs from './views/FAQs.vue'
// import Contact from './views/Contact.vue'
import Upload from '@/components/upload.vue'
import Blast from '@/components/blast.vue'
import Blast_job from '@/components/blast_job.vue'
import Predict from '@/components/pred.vue'
import Predict_job from '@/components/pred_job.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'home',
            component: Home,
            children: [
                { path: 'upload', component: Upload },
                { path: 'blast', component: Blast },
                { path: 'blast_job', component: Blast_job },
                { path: 'predict', component: Predict },
                { path: 'predict_job', component: Predict_job }
            ]
        },
        {
            path: '/download',
            name: 'download',
            component: Download
        },
        {
            path: '/FAQs',
            name: 'FAQs',
            component: FAQs
        },
        {
            path: '/contact',
            name: 'contact',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import ( /* webpackChunkName: "about" */ './views/Contact.vue')
        }
    ]
})